
import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
import ColorSet from './ColorSet';

export default class ColorSetEditor extends PropertyEditor {
    constructor(props, context) {
        super(props, context);
        this.state = {
            // colors: []
        }
    }
    componentDidMount() {

    }

    // componentWillReceiveProps(nextProps) {
    //     super.componentWillReceiveProps(nextProps);
    //     if (nextProps.value === this.props.value)
    //         return;

    //     this.setState({ colors: nextProps.value });
    // }
    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }
    onChange(colors) {
        this.props.source.value = [...colors];
        this.setState({})
    }
    render() {
        let colors = [...this.props.source.value || []];
        return (
            <div>
                <ColorSet colors={colors} onChange={this.onChange.bind(this)}></ColorSet>

            </div>

        );
    }
}

PropertyGridUtils.register("colorSet", (source, propertyGrid) => <ColorSetEditor source={source} propertyGrid={propertyGrid} />);